const bazarListSl = {
	banner: {
		title: 'බසාර්',
		subtitle: 'සාම්ප්‍රදායික වෙළඳපොළවලින් මිලදී ගන්න',
		breadcrumbLabel: 'බසාර්',
		currentPlaceholder: 'ආහාර සෙවීම...'
	},
	filter: {
		title: 'පෙරහන් විකල්ප',
		searchPlaceholder: 'බසාර් සෙවෙන්න...',
		district: 'දිස්ත්‍රික්කය',
		upazilla: 'උපසිලාව',
		size: 'බසාර් ප්‍රමාණය',
		sortBy: 'තෝරන්න',
		sortOptions: {
			name: 'නම',
			storeCount: 'සාප්පු ගණන',
			rating: 'ඇගැයුම්',
			visitors: 'ජනප්‍රියතාව'
		},
		clearShort: 'මකන්න',
		clearAll: 'සියල්ල මකන්න',
		activeFilters: 'සක්‍රීය පෙරහන්:',
		labels: {
			search: 'සෙවුම්',
			district: 'දිස්ත්‍රික්කය',
			upazilla: 'උපසිලාව',
			size: 'ප්‍රමාණය'
		}
	},
	results: {
		foundSuffix: 'බසාර් හමු විය',
		none: 'බසාර් කිසිවක් හමු නොවිනි',
		page: 'පිටුව'
	},
	empty: {
		title: 'ඔබගේ සෙවුමට නොගැළපෙන බසාර්',
		subtitle: 'වෙනත් පෙරහන් උත්සාහ කරන්න',
		clear: 'සියලු පෙරහන් මකන්න'
	},
	card: {
		stores: 'සාප්පු',
		dailyVisitors: 'දානික സന്ദർശකයින්',
		specialties: 'විශේෂාංග:',
		details: 'විස්තර',
		visit: 'පිවිසෙන්න'
	},
	dialog: {
		title: 'අභිනාන්දනයි!',
		selected: 'ඔබගේ බසාර් තෝරා ගන්නා ලදී',
		instruction: 'ඔබගේ වර්තමාන බසාර් තෝරා ඇත. පහළින් විභාගයක් තෝරන්න:',
		categoryPrompt: 'ඔබට කුමක් මිලදී ගැනීමට අවශ්‍යද?',
		bottomNotePrefix: 'මෙම නිෂ්පාදන ලබාදෙනුයේ',
		bottomNoteSuffix: '',
		close: 'පසුව බලන්න'
	}
};

export default bazarListSl;


